import { Icon } from "./CircleIconFlag.styled";

const CircleIconFlag = ({ className }) => {
  return <Icon className={className} />;
};

export default CircleIconFlag;
